import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Alert, Grid, Spinner, Text } from "~/components-shared";
import api from "~/lib/api";
import { handleError } from "~/lib/helpers";
import styled from "styled-components";
import progressFlowSelectors from "~/store/progressFlow/selectors";
import ProgressFlowDetailsFootprintsCard from "../ProgressFlowDetailsFootprintsCard";
import ProgressFlowDetailsCard from "../ProgressFlowDetailsCard";
const Wrapper = styled.div`
  flex-direction: column;
  height: 100%;
  display: flex;
  align-items: start;
`;
const ProgressFlowDetailsContent = _ref => {
  let {
    progressFlowItem
  } = _ref;
  const {
    t
  } = useTranslation();
  const error = useSelector(progressFlowSelectors.getError);
  const [footprintLoading, setFootprintLoading] = useState(false);
  const [footprintError, setFootprintError] = useState("");
  const [footprints, setFootprints] = useState([]);
  const footprintIds = progressFlowItem?.footprintIds;
  useEffect(() => {
    if (progressFlowItem && footprintIds) {
      setFootprintLoading(true);
      setFootprintError("");
      api.fetchProgressFlowItemFootprints({
        footprintIds
      }).then(result => {
        setFootprints(result);
      }).catch(e => setFootprintError(handleError(e))).finally(() => {
        setFootprintLoading(false);
      });
    }
  }, [footprintIds]);
  return /*#__PURE__*/React.createElement(Wrapper, null, error && /*#__PURE__*/React.createElement(Alert, {
    severity: "danger",
    s: {
      mb: 3
    },
    fullWidth: true
  }, error), progressFlowItem ? /*#__PURE__*/React.createElement(Grid, {
    cols: 2,
    template: "auto minmax(400px, 600px)",
    gap: 3,
    style: {
      overflow: "hidden"
    },
    s: {
      mt: 4
    },
    fullWidth: true
  }, /*#__PURE__*/React.createElement(ProgressFlowDetailsCard, {
    progressFlowItem: progressFlowItem,
    fullWidth: true,
    style: {
      overflow: "auto",
      height: "100%",
      minHeight: "0"
    }
  }), /*#__PURE__*/React.createElement(Grid, {
    cols: 1,
    style: {
      overflow: "auto",
      height: "100%",
      minHeight: "0",
      alignContent: "start"
    }
  }, /*#__PURE__*/React.createElement(Text, {
    element: "h3",
    s: {
      mb: 3
    }
  }, t("ProgressFlowDetails.relatedFootprints")), footprintLoading ? /*#__PURE__*/React.createElement(Spinner, {
    center: true,
    s: {
      my: 6
    }
  }) : footprints.length ? /*#__PURE__*/React.createElement(React.Fragment, null, footprintError && /*#__PURE__*/React.createElement(Alert, {
    severity: "danger",
    s: {
      mb: 3
    },
    fullWidth: true
  }, footprintError), /*#__PURE__*/React.createElement(ProgressFlowDetailsFootprintsCard, {
    footprints: footprints,
    fullWidth: true,
    style: {
      overflow: "auto",
      height: "100%"
    }
  })) : /*#__PURE__*/React.createElement(Text, {
    display: "block",
    fontSize: 4,
    color: "textSecondary",
    weight: "semiBold"
  }, t("ProgressFlowDetails.noFootprintsFound")))) : /*#__PURE__*/React.createElement(Text, {
    element: "h2",
    color: "textSecondary"
  }, t("ProgressFlowDetails.somethingWentWrong")));
};
export default ProgressFlowDetailsContent;